<template>
    <div class="flex flex-column flex-items-dead-center validate-user">
        <p>{{transactionFeedback.message}}</p>
        <template v-if="transactionFeedback.code == 409 || transactionFeedback.code == 404 || transactionFeedback.code == 200">
            <router-link class="btn btn-outline-default" as="button" :to="{ name: 'Home'}">Go to Home</router-link>
        </template>
        <template v-if="transactionFeedback.code == 424 || transactionFeedback.code == 400">
            <button class="btn btn-success" @click.prevent="resendVerificationEmail">
                Resend Verification
            </button>
            <div class="form-group">
                <div v-if="message" class="alert alert-success" role="alert">{{message}}</div>
            </div>
        </template>
    </div>
</template>
<script>
import generalServices from '../services/GeneralServices';
import SvgIconContainer from "../components/Svg/SvgIconContainer.vue";

export default {
    name: 'ActivateUser',
    components: {
        SvgIconContainer
    },
    data() {
        return {
            email: null,
            status: null,
            message: "",
            transactionFeedback: {
                'message': "",
                'code': ""
            }
        };
    },
    computed: {
        loggedIn() {
            //return this.$store.state.auth.status.loggedIn;
            return false;
        }
    },
    created() {
        if (this.loggedIn) {
            this.$router.push('/hub/users/profile');
        }
    },
    async mounted() {
        this.email = this.$route.query.email

        if (this.$route.query.uidb64 && this.$route.query.token) {
            // send token to backend for verification
            const uidb64 = this.$route.query.uidb64
            const token = this.$route.query.token
            try {
                let response = await generalServices.GET_DATA("users/activate/", 
                    {
                        'uidb64': uidb64,
                        'token': token
                    }
                );
                this.transactionFeedback['message'] = response.data;
                this.transactionFeedback['code'] = response.status;
            } catch (err) {
                this.transactionFeedback['message'] = err.response.data;
                this.transactionFeedback['code'] = err.response.status;
            }

        }
    },
    methods: {
        handleActivation() {
            this.$store.dispatch('auth/activate', this.additionalInfo).then(
                () => {
                    this.registering = false;
                    this.message = "";
                },
                error => {
                    this.message =
                        (error.response && error.response.data) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        async resendVerificationEmail() {
            this.message = "Resending verification email, please wait!";
            try {
                let response = await generalServices.POST_DATA("resendVerification/", 
                    {
                        'email': this.email
                    }
                );
                this.message = "";
                this.transactionFeedback['message'] = response.data;
                this.transactionFeedback['code'] = response.status;
            } catch (err) {
                this.message = "";
                this.transactionFeedback['message'] = err.response.data;
                this.transactionFeedback['code'] = err.response.status;
            }
        },
        checkSuccessful (value) {
            return /^(2)/.test(value);
        }
    }
};
</script>
<style lang="scss">
</style>
